<template>
  <div>
    <v-dialog v-model="dialog" :key="key" max-width="600">
      <ManageStockExit
        :stockItemId="stockItemId"
        :institutionId="institutionId"
        :exitProp="exit"
        @close="dialog = false"
        @confirm="list(), (dialog = false), $emit('update')"
      />
    </v-dialog>

    <div class="d-flex align-center justify-space-between ma-4">
      <h3>{{ $t('Saídas') }}</h3>

      <div>
        <v-btn
          class="primary-button mr-2"
          depressed
          @click=";(exit = null), (key = !key), (dialog = true)"
        >
          {{ $t('Nova saída') }}
        </v-btn>

        <v-btn class="secondary-button" depressed @click="show = !show">
          {{ show ? $t('Fechar') : $t('Filtros') }}
        </v-btn>
      </div>
    </div>

    <v-expand-transition>
      <div v-show="show">
        <v-form ref="form">
          <v-row class="ma-0" align="center" justify="end">
            <v-col>
              <span class="text ml-1">{{ $t('Data inicial') }}</span>
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="primary-input"
                    placeholder="00/00/0000"
                    :value="formatDate(filter.start)"
                    :rules="
                      filter.final
                        ? [
                            () =>
                              filter.start <= filter.final || 'Data inválida',
                          ]
                        : []
                    "
                    outlined
                    readonly
                    v-bind="attrs"
                    hide-details="auto"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker locale="pt" v-model="filter.start">
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col>
              <span class="text ml-1">{{ $t('Data final') }}</span>
              <v-menu
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="primary-input"
                    placeholder="00/00/0000"
                    :value="formatDate(filter.final)"
                    :rules="
                      filter.start
                        ? [
                            () =>
                              filter.final >= filter.start || 'Data inválida',
                          ]
                        : []
                    "
                    outlined
                    readonly
                    hide-details="auto"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker locale="pt" v-model="filter.final">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="auto">
              <div class="mt-3">
                <v-btn class="clear-button mr-2" depressed @click="reset">
                  {{ $t('Limpar') }}
                </v-btn>
                <v-btn @click="applyFilter" class="secondary-button" depressed>
                  {{ $t('Aplicar filtros') }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="exits"
      :items-per-page="filter.pageSize"
      class="main-table ma-2"
      hide-default-footer
      hide-default-header
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.exitDate`]="{ item }">
        <span> {{ formatDate(item.exitDate) }} </span>
      </template>

      <template #[`item.nf`]="{ item }">
        <span> {{ item.nf ? item.nf : $t('Sem registros') }} </span>
      </template>

      <template #[`item.unitaryValue`]="{ item }">
        <span> {{ formatCurrency(item.unitaryValue) }} </span>
      </template>

      <template #[`item.totalValue`]="{ item }">
        <span> {{ formatCurrency(item.totalValue) }} </span>
      </template>

      <template #[`item.department.name`]="{ item }">
        <span> {{ item.department ? item.department.name : '-' }} </span>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="edit-button mr-2"
              icon
              @click="edit(item)"
              text
              v-on="on"
            >
              <v-icon size="22">mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ filter.pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="filter.pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="items.length">
          <span> 1 - {{ items.length }} de {{ filter.totalItems }} </span>
          <br />
          <span>
            {{ $t('Selecionados') }}:
            {{ items.length }}
          </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ManageStockExit from './ManageStockExit.vue'
import FormatDate from '../../../../Utils/FormatDate'
import ApiService from '../../../../services/ApiService'

export default {
  name: 'ManageExits',

  props: {
    stockItemId: Number,
    institutionId: Number,
  },

  components: { ManageStockExit },

  created() {
    this.list()
  },

  data() {
    return {
      apiService: new ApiService(),
      key: false,
      dialog: false,
      show: false,
      items: [],
      exits: [],
      exit: {},
      sizes: [10, 30, 90, 180],
      filter: {
        start: '',
        final: '',
        stockItemId: null,
        page: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
      },
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Quantidade',
          align: 'center',
          value: 'quantity',
        },
        {
          text: 'Valor unitário',
          align: 'center',
          value: 'unitaryValue',
        },
        {
          text: 'Valor total',
          align: 'center',
          value: 'totalValue',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department.name',
        },
        {
          text: 'Data/Hora',
          align: 'center',
          value: 'exitDate',
          sortable: false,
        },
        {
          text: 'Usuário',
          align: 'center',
          value: 'registrationUser.name',
          sortable: false,
        },
        {
          text: 'Motivo/OS',

          align: 'center',
          value: 'reason',
          sortable: false,
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
    }
  },

  methods: {
    formatCurrency(value) {
      return value != null ? value.toInstLocale() : 0
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    applyFilter() {
      if (this.$refs.form.validate()) {
        this.list()
      }
    },

    reset() {
      this.filter.page = 1
      this.filter.start = ''
      this.filter.final = ''
      this.list()
    },

    edit(item) {
      this.exit = item
      this.key = !this.key
      this.dialog = true
    },

    list() {
      this.filter.stockItemId = this.stockItemId

      this.apiService
        .post('stockExit/list/paginate', this.filter)
        .then((response) => {
          this.exits = response.content.entities

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
    },
  },

  watch: {
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
    'filter.pageSize': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },
}
</script>

<style scoped lang="scss">
.table-custom {
  &::v-deep .v-data-table__wrapper {
    thead {
      border: none !important;

      th {
        border: none !important;
        &:first-child {
          border-radius: 4px 0 0 4px;
        }

        &:last-child {
          border-radius: 0 4px 4px 0;
        }
      }
    }
  }
}
.pagination {
  margin: 1.5rem 0;
  background: $grey-1;
  border-radius: 4px;
  padding: 0.8rem 1.3rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .item-pagination {
    flex: 1 1 100px;
    margin: 0.5rem 0;
    .btn {
      border-radius: 4px;
      background: #c7c9ca;
      font-weight: bold;
    }
    .registros {
      span {
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        color: $grey-2;
      }
    }
  }
  .block-one {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .block-two {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .pagination-item {
      &::v-deep .v-pagination {
        li {
          button {
            box-shadow: none !important;
            background: none !important;
            color: $grey-2;
            font-weight: 500;
          }

          .v-pagination__item--active {
            color: $black-1;
          }
        }
      }
    }
  }

  @media (max-width: 406px) {
    .block-one {
      justify-content: center;
    }
    .block-two {
      justify-content: center;
    }
  }
}
</style>
